import React from "react";
import PropTypes from "prop-types";
import { Div, H1, P, Button } from "glamorous";

import styles from "../../styles";

const Error = ({ error, setError, setArea }) => (
  
  <Div
    className="container container--generic"
  >
    <Div textAlign="center">
      <H1 css={styles.error.header}>{error.heading}</H1>
      <Div style={styles.error.errorContainer}>
        <P css={styles.error.errorTitle}>{error.title}</P>
        <P css={styles.error.errorMessage}>{error.message}</P>
      </Div>
      {console.log(error)}
      {
        error.cta &&
        <Button
          css={styles.error.cta}
          onClick={() => {
            setError(null);
            setArea(error.prevArea);
          }}
        >
          {error.cta}
        </Button>
      }
    </Div>
  </Div>
);

Error.propTypes = {
  error: PropTypes.object.isRequired,
  setError: PropTypes.func.isRequired,
  setArea: PropTypes.func.isRequired
};

export default Error;



// WEBPACK FOOTER //
// ./src/components/areas/Error.js